import {
  findRowListField,
  normalizeType,
  ROW_LIST_FIELD_TYPE,
} from '@streamlain/field-types';

import type { WorkflowSchema } from '../services/workflow-client';

/** The inputs a column fills; a row-list input receives the rows of the run instead. */
export function mappableInputs(
  input: WorkflowSchema['input']
): WorkflowSchema['input'] {
  const mappable = (field: { type: string }) =>
    normalizeType(field.type) !== ROW_LIST_FIELD_TYPE;
  return {
    required: input.required.filter(mappable),
    optional: input.optional.filter(mappable),
  };
}

/** Whether the workflow runs once for all rows of a run: it has a row-list input. */
export function runsOnceForAll(schema: WorkflowSchema | null): boolean {
  return (
    !!schema &&
    !!findRowListField([...schema.input.required, ...schema.input.optional])
  );
}
